import React from 'react';
import Skeleton from 'components/LoadingSkeleton';

const ProfileCompletenessSkeleton = () => {
  const separator = (
    <hr className="container mx-auto mt-8 border-color-bg-input-lightmode-primary dark:border-color-bg-input-darkmode-primary max-sm:mt-ds-xl" />
  );

  return (
    <>
      {separator}
      <div className="container mx-auto mt-8 max-sm:mt-ds-xl max-sm:px-4">
        <div className="mb-ds-xl flex flex-col gap-1 max-sm:mb-ds-md">
          <h5 className="typography-product-heading-compact-desktop max-sm:typography-product-subheading">
            Profile Completeness
          </h5>
          <span className="max-sm:typography-product-caption text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            Complete all steps to unlock your full coaching potential and grow your business.
          </span>
        </div>
        <div className="grid grid-cols-1 gap-10  rounded-3xl border border-color-border-card-lightmode p-ds-3xl shadow-[0px_4px_16px_0px_rgba(0,0,0,0.08)] dark:border-color-border-card-darkmode max-sm:gap-y-6 sm:grid-cols-2 lg:grid-cols-4">
          {/* Percentage Circle Skeleton */}
          <div className="flex justify-center">
            <Skeleton circle width={128} height={128} />
          </div>
          {/* CTA Cards Skeleton */}
          <div className="space-y-4">
            <Skeleton height={24} width="80%" />
            <Skeleton height={16} width="60%" />
            <Skeleton height={40} width="100%" />
          </div>
          <div className="space-y-4">
            <Skeleton height={24} width="80%" />
            <Skeleton height={16} width="60%" />
            <Skeleton height={40} width="100%" />
          </div>
          <div className="space-y-4">
            <Skeleton height={24} width="80%" />
            <Skeleton height={16} width="60%" />
            <Skeleton height={40} width="100%" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileCompletenessSkeleton;
